function init_passwords(){
    $("[data-input='password']").each(function (index, input) {

        if($(input).data('inited')) return;

        if($(input).data('autocomplete') === "off"){
            setTimeout(function() {
                $(input).val($(input).attr('value'));
            }, 500);
        }



        $(input).parent().find('.toggle-password').on('click', function (e) {
            if ($(input).attr("type") === "password") {
                $(input).attr("type", "text");
            } else {
                $(input).attr("type", "password");
            }
        });

        $(input).data('inited', true);
    })
}

$(function(){
    init_passwords();
});